<div class="timelineContainer">
  <!--tooltip current year-->
  @if (isActiveCursorDate) {
    <div class="popup" [style.left]="positionTooltip()">
      <div class="verticalLinePopUp"></div>
    {{currentValue}}</div>
  }

  <!--couleur des zones-->
  @for (param of zoneColor; track param) {
    <div class="zoneColor"
      appPositionAndStyle
    [positionAndStyle]="param"></div>
  }

  <!--separate zone-->
  @for (position of positionSeparators; track position) {
    <div class="splitZone"
      appPositionAndStyle
    [position]="position"></div>
  }

  <!--regular interval split-->
  @for (position of positionIntervals; track position) {
    <div class="splitInterval"
      appPositionAndStyle
    [position]="position.left"></div>
  }

  @for (position of positionIntervals; track position) {
    <div class="splitIntervalTimeText"
      appPositionAndStyle
      [position]="position.left">{{position.year}}
    </div>
  }

  <!--dot history periode separator-->
  @for (dot of dots; track dot) {
    <div class="circle"
      appPositionAndStyle
    [position]="dot"></div>
  }

  <!--dot history midlle periode separator-->
  @for (dot of dotsMiddle; track dot) {
    <div class="circle"
      appPositionAndStyle
    [position]="dot"></div>
  }

  <div class="dateDebut splitIntervalTimeText">
    {{minValue}}
  </div>

  <div class="dateFin splitIntervalTimeText">
    {{maxValue}}
  </div>

  <!--slider-->
  <input type="range" name="sliderCutom"
    [attr.min]="minValue"
    [attr.max]="maxValue"
    value="0"
    [(ngModel)]="currentValue"
    (input)="sliderMove($event)"
    (click)="sliderClick($event)"
    (touchend)="sliderClick($event)">
  </div>
